import { enLocale__SkillsChart } from "../../common/skills-chart/locales";
import { enLocale__PositionBlock } from "../../modules/full-cv/position-block-locales";
import { enLocale__VisibilityToggles } from "../../modules/full-cv/visibility-toggles-locales";
import { enLocale__Interview } from "../../modules/interview/locales";
import { enLocale__MiniCv } from "../../modules/mini-cv/locales";
import { enLocale__ContactPage } from "../../pages/contact/locales";
import { enLocale__RightSwitcher } from "../../modules/sunday-top-nav/buttons/right-toggle/locales";
import { enLocale__TopNavStats } from "../../modules/sunday-top-nav/locales";
import { enLocale__UserButton } from "../../modules/sunday-top-nav/buttons/user-button/locales";
import { enLocale__Navigation } from "../../routes/locales";
import { enLocale__Analytics } from "../../analytics/locales";
import { MergeTranslateKeys } from "../keys";

const messages: MergeTranslateKeys = {
    cardAbout_label: 'About me',
    footerNoTracking__label: 'Analytics is collected only with your consent',
    ...enLocale__Analytics,
    ...enLocale__SkillsChart,
    ...enLocale__RightSwitcher,
    ...enLocale__UserButton,
    ...enLocale__Navigation,
    ...enLocale__VisibilityToggles,
    ...enLocale__PositionBlock,
    ...enLocale__Interview,
    ...enLocale__ContactPage,
    ...enLocale__MiniCv,
    ...enLocale__TopNavStats
}

export default messages;